import React from "react";
import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import ClassroomList from "../../components/ClassroomList";

const Classrooms: React.FC = () => {
  return (
    <Grid container spacing={3} style={{ marginBottom: "2rem" }}>
      <Grid item xs={12}>
        <Card>
          <CardHeader title="Classrooms" />
          <CardContent>
            <ClassroomList />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Classrooms;
